import { useLocation, useParams } from 'react-router-dom';

const INVITE_TOKEN_STORAGE_KEY = 'invite_token';

export function useInviteToken() {
  const { token: paramToken } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const queryToken = searchParams.get('token');

  const resolvedToken = paramToken || queryToken || localStorage.getItem(INVITE_TOKEN_STORAGE_KEY);

  if (resolvedToken) {
    localStorage.setItem(INVITE_TOKEN_STORAGE_KEY, resolvedToken);
  }

  return resolvedToken;
}

export function buildInvitePath(token, subpath = '') {
  const path = subpath ? `/i/${subpath}` : '/i';

  if (!token) {
    return path;
  }

  return `${path}?token=${encodeURIComponent(token)}`;
}
